import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getErrorMessage } from '../../../api';
import { destroyHoldApi } from '../../../api/booking';
import { BookingState, DestroyParams } from '../../../types/booking';
import { RootState } from '../../store';

export const destroyBooking = createAsyncThunk(
  'admin/destroy/booking',
  async (params: DestroyParams, { dispatch, rejectWithValue }) => {
    try {
      const response = await destroyHoldApi(params);
      const { data, status } = response;
      if (status) {
        dispatch(setUpdate({ status: status, data: data }));
      }
      return true;
    } catch (error: any) {
      const { response } = error;
      dispatch(setUpdateError(response));
      return rejectWithValue(getErrorMessage(error));
    }
  },
);
export const destroyBookingSlice = createSlice({
  name: 'destroyBooking',
  initialState: {
    error: false,
    loading: false,
    success: false,
    status: 0,
    message: '',
    errorDetail: null,
  } as BookingState,
  reducers: {
    setUpdate: (state: BookingState, { payload }) => {
      const { message } = payload.data;
      state.status = payload?.status;
      state.message = message;
    },
    setUpdateError: (state: BookingState, { payload }) => {
      const { errors } = payload.data;
      state.status = payload?.status;
      state.errorDetail = errors;
    },
    resetDestroyBooking: (state: BookingState) => {
      state.success = false;
      state.message = '';
      state.errorDetail = null;
      state.status = 0;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(destroyBooking.pending, (state: BookingState) => {
      state.loading = true;
      state.success = false;
    });
    builder.addCase(destroyBooking.fulfilled, (state: BookingState) => {
      state.loading = false;
      state.success = true;
      state.error = false;
    });
    builder.addCase(destroyBooking.rejected, (state: BookingState, { payload }) => {
      state.loading = false;
      state.success = false;
      state.error = true;
      state.message = payload;
    });
  },
});

export const destroyBookingSelector = (state: RootState) => state.destroyBooking;
export const { setUpdateError, setUpdate, resetDestroyBooking } = destroyBookingSlice.actions;
